<div class="flex items-center justify-center">
  <div class="text-center">
    <h1 class="text-4xl font-bold mb-4">Accesso Negato</h1>
    <p class="text-gray-700 text-lg mb-6">
      Non sei autorizzato ad accedere a questa pagina.
    </p>
  </div>
</div>
